module.exports = __webpack_public_path__ + "img/transact.e3db625d.png";